module.exports = __webpack_public_path__ + "static/media/AvenirNextLTPro-DemiIt.da0ecba3.otf";